import httpHelper from '../../helpers/HttpHelper';
import environments from '../common/environments/environments';

const http = new httpHelper();

export const MyAccountActions = {
	Logout: logout,
	SignIntoken: signIntoken
};

function logout() {
	return http.post(environments.LOGOUT);
}

function signIntoken() {
	return http.post(environments.SIGNINTOKEN);
}
